import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";
import WhatsAppSticky from "@/components/landing/WhatsAppSticky";
import { setPageMeta } from "@/lib/pageMeta";

export default function ThankYouPage() {
  const navigate = useNavigate();

  useEffect(() => {
    setPageMeta({
      title: "Thank You — Utsah",
      description: "Thank you for your enquiry. Our team will be in touch with you shortly.",
    });
    // Prevent thank-you page from being indexed by search engines.
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    const previous = robots.getAttribute("content") || "";
    robots.setAttribute("content", "noindex, nofollow");
    return () => {
      if (previous) robots.setAttribute("content", previous);
      else robots.remove();
    };
  }, []);

  return (
    <div className="utsah-app" data-testid="thank-you-page">
      <Nav />
      <section
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "120px 24px 96px",
          background: "var(--u-cream)",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: 620 }}>
          <div
            className="eyebrow"
            style={{ display: "inline-flex", marginBottom: 20 }}
            data-testid="thank-you-eyebrow"
          >
            Enquiry Received
          </div>
          <h1 className="section-headline" style={{ marginBottom: 24 }} data-testid="thank-you-heading">
            Thank <em>you.</em>
          </h1>
          <p className="section-sub" style={{ marginBottom: 16 }} data-testid="thank-you-message-1">
            We've received your enquiry.
          </p>
          <p className="section-sub" style={{ marginBottom: 40, opacity: 0.8 }} data-testid="thank-you-message-2">
            Our team will get in touch with you shortly to understand your requirements and help you find the right gifting solution.
          </p>
          <button
            className="hero-cta"
            onClick={() => navigate("/")}
            data-testid="thank-you-home-btn"
          >
            Back to Home
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden>
              <path d="M1 6h15M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </section>
      <Footer />
      <WhatsAppSticky />
    </div>
  );
}
